import React, { Component } from 'react'

/*LIBRARY COMPONENT IMPORTS*/
import ParticleJS from '../../effects/ParticleJS.js';
import { motion } from 'framer-motion'

/*COMPONENT IMPORTS */
import Footer from '../../navigation/footer/Footer.js';
import Header from '../../navigation/header/Header.js';
import Accordion from '../../navigation/accordion/Accordion.js';
import LearnInPageNav from '../LearnPages/LearnInPageNav.js';

/*ASSET IMPORTS*/
import wormIcon from '../../../assets/worm.svg';

/*STYLE IMPORTS*/
import './LearnPage.css'

/*TEXT IMPORTS*/
import text from '../../../assets/LearnAssets/text/MalwareText.json';

const wrapperAnimation = {
    initial: {
        opacity: 0,
        transition: {
            duration: 0.7,
            ease: [0.87, 0, 0.13, 1],
            staggerChildren: 0.2
        }
    },
    show: {
        opacity: 1,
        transition: {
            duration: 0.7,
            ease: [0.87, 0, 0.13, 1],
            staggerChildren: 0.2
        }
    },
    exit: {
        transition: {
            duration: 0.7,
            ease: [0.87, 0, 0.13, 1],
            staggerChildren: 0.2
        }
    }
}

const linkAnimations = {
    initial: { opacity: 0, y: -1000 },
    show: {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: [0.87, 0, 0.13, 1],
        transition: {
            type: "spring",
            stiffness: 25,
        }
    },
    exit: {
        opacity: 0,
        y: -700,
        duration: 0.7,
        ease: [0.87, 0, 0.13, 1],
        transition: {
            type: "spring",
            stiffness: 25,
        }
    }
}

const navAnimations = {
    initial: { opacity: 0, x: -1000 },
    show: {
        opacity: 1,
        x: 0,
        transition: {
            type: "spring",
            stiffness: 25,
        },
        staggerChildren: 0.1
    },
    exit: {
        opacity: 0,
        x: -1000,
        duration: 0.7,
        ease: [0.87, 0, 0.13, 1],
        transition: {
            type: "spring",
            stiffness: 25,
        }
    }
}

const categoriesAnimations = {
    initial: { opacity: 0 },
    show: {
        opacity: 1,
        duration: 0.7,
        ease: [0.87, 0, 0.13, 1],
        transition: {
            type: "spring",
            stiffness: 25,
        }
    },
    exit: { opacity: 0 }
}

export default class LearnMalware extends Component {
    render() {
        return (
            <motion.div
                variants={wrapperAnimation}
                animate="show"
                initial="initial"
                exit="exit">
                <Header />
                <LearnInPageNav />
                <div className="topic-content-container">

                    <motion.div
                        className="topic-icon"
                        variants={linkAnimations}>
                        <img className="topic-icon" src={ wormIcon }/>
                    </motion.div>

                    <motion.div
                        className="topic-menu-wrapper"
                        variants={navAnimations}>
                        <div className="topic-menu">
                            <h3>Navigation</h3>
                            <Accordion title="Virus" anchors={{
                                description: "#virus-description",
                                example: "#virus-example",
                                mitigation: "#virus-mitigation"
                            }}/>
                            <Accordion title="Worms" anchors={{
                                description: "#worms-description",
                                example: "#worms-example",
                                mitigation: "#worms-mitigation"
                            }}/>
                            <Accordion title="Logic Bombs" anchors={{
                                description: "#logic-bombs-description",
                                example: "#logic-bombs-example",
                                mitigation: "#logic-bombs-mitigation"
                            }}/>
                            <Accordion title="Backdoor" anchors={{
                                description: "#backdoor-description",
                                example: "#backdoor-example",
                                mitigation: "#backdoor-mitigation"
                            }}/>
                            <Accordion title="Trojans" anchors={{
                                description: "#trojans-description",
                                example: "#trojans-example",
                                mitigation: "#trojans-mitigation"
                            }}/>
                            <Accordion title="Remote Access Trojans (RATs)" anchors={{
                                description: "#rats-description",
                                example: "#rats-example",
                                mitigation: "#rats-mitigation"
                            }}/>
                            <Accordion title="Keylogger" anchors={{
                                description: "#keylogger-description",
                                example: "#keylogger-example",
                                mitigation: "#keylogger-mitigation"
                            }}/>
                            <Accordion title="Spyware" anchors={{
                                description: "#spyware-description",
                                example: "#spyware-example",
                                mitigation: "#spyware-mitigation"
                            }}/>
                            <Accordion title="Adware" anchors={{
                                description: "#adware-description",
                                example: "#adware-example",
                                mitigation: "#adware-mitigation"
                            }}/>
                            <Accordion title="Bots, Botnets, and Zombies" anchors={{
                                description: "#bots-description",
                                example: "#bots-example",
                                mitigation: "#bots-mitigation"
                            }}/>
                            <Accordion title="Rootkits" anchors={{
                                description: "#rootkits-description",
                                example: "#rootkits-example",
                                mitigation: "#rootkits-mitigation"
                            }}/>
                        </div>
                    </motion.div>

                    <motion.div
                        className="topic-content-wrapper"
                        variants={categoriesAnimations}>
                        <h2 className="topic-content-title">Malware</h2>

                        <div className="topic-content">
                            <div id="virus-content">
                                <h4 id="email-phishing-title">Virus</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="virus-description">What is a Virus?</h3>
                                    <p className="text-content">{ text.virus.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="virus-example">What Do Viruses Look Like?</h3>
                                    <p className="text-content">{ text.virus.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="virus-mitigation">How Can I Protect Myself Against Viruses?</h3>
                                    <p className="text-content">{ text.virus.mitigation }</p>
                                </div>
                            </div>

                            <div id="worms-content">
                                <h4 id="email-phishing-title">Worms</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="worms-description">What is a Worm?</h3>
                                    <p className="text-content">{ text.worms.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="worms-example">What Do Worms Look Like?</h3>
                                    <p className="text-content">{ text.worms.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="worms-mitigation">How Can I Protect Myself Against Worms?</h3>
                                    <p className="text-content">{ text.worms.mitigation }</p>
                                </div>
                            </div>

                            <div id="logic-bombs-content">
                                <h4 id="email-phishing-title">Logic Bombs</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="logic-bombs-description">What is a Logic Bomb?</h3>
                                    <p className="text-content">{ text.logicbombs.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="logic-bombs-example">What Do Logic Bombs Look Like?</h3>
                                    <p className="text-content">{ text.logicbombs.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="logic-bombs-mitigation">How Can I Protect Myself Against Logic Bombs?</h3>
                                    <p className="text-content">{ text.logicbombs.mitigation }</p>
                                </div>
                            </div>

                            <div id="backdoor-content">
                                <h4 id="email-phishing-title">Backdoor</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="backdoor-description">What is a Backdoor?</h3>
                                    <p className="text-content">{ text.backdoor.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="backdoor-example">What Do Backdoors Look Like?</h3>
                                    <p className="text-content">{ text.backdoor.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="backdoor-mitigation">How Can I Protect Myself Against Backdoors?</h3>
                                    <p className="text-content">{ text.backdoor.mitigation }</p>
                                </div>
                            </div>
                            
                            <div id="trojans-content">
                                <h4 id="email-phishing-title">Trojans</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="trojans-description">What is a Trojan?</h3>
                                    <p className="text-content">{ text.trojans.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="trojans-example">What Does a Trojan Look Like?</h3>
                                    <p className="text-content">{ text.trojans.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="trojans-mitigation">How Can I Protect Myself Against Trojans?</h3>
                                    <p className="text-content">{ text.trojans.mitigation }</p>
                                </div>
                            </div>
                            
                            <div id="rats-content">
                                <h4 id="email-phishing-title">Remote Access Trojans (RATs)</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="rats-description">What is a RAT?</h3>
                                    <p className="text-content">{ text.rats.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="rats-example">What Do RATs Look Like?</h3>
                                    <p className="text-content">{ text.rats.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="rats-mitigation">How Can I Protect Myself Against RATs?</h3>
                                    <p className="text-content">{ text.rats.mitigation }</p>
                                </div>
                            </div>

                            <div id="keyloggers-content">
                                <h4 id="email-phishing-title">Keyloggers</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="keylogger-description">What is a Keylogger?</h3>
                                    <p className="text-content">{ text.keylogger.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="keylogger-example">What Do Keyloggers Look Like?</h3>
                                    <p className="text-content">{ text.keylogger.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="keylogger-mitigation">How Can I Protect Myself Against Keyloggers?</h3>
                                    <p className="text-content">{ text.keylogger.mitigation }</p>
                                </div>
                            </div>

                            <div id="spyware-content">
                                <h4 id="email-phishing-title">Spyware</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="spyware-description">What is Spyware?</h3>
                                    <p className="text-content">{ text.spyware.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="spyware-example">What Does Spyware Look Like?</h3>
                                    <p className="text-content">{ text.spyware.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="spyware-mitigation">How Can I Protect Myself Against Spyware?</h3>
                                    <p className="text-content">{ text.spyware.mitigation }</p>
                                </div>
                            </div>

                            <div id="adware-content">
                                <h4 id="email-phishing-title">Adware</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="adware-description">What is Adware?</h3>
                                    <p className="text-content">{ text.adware.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="adware-example">What Does Adware Look Like?</h3>
                                    <p className="text-content">{ text.adware.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="adware-mitigation">How Can I Protect Myself Against Adware?</h3>
                                    <p className="text-content">{ text.adware.mitigation }</p>
                                </div>
                            </div>

                            <div id="bots-content">
                                <h4 id="email-phishing-title">Bots, Botnets, and Zombies</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="bots-description">What are Bots, Botnets, and Zombies?</h3>
                                    <p className="text-content">{ text.bots.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="bots-example">What Do Bots / Botnets / Zombies Look Like?</h3>
                                    <p className="text-content">{ text.bots.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="bots-mitigation">How Can I Protect Myself Against Bots / Botnets / Zombies?</h3>
                                    <p className="text-content">{ text.bots.mitigation }</p>
                                </div>
                            </div>

                            <div id="rootkits-content">
                                <h4 id="email-phishing-title">Rootkits</h4>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="rootkits-description">What are Rootkits?</h3>
                                    <p className="text-content">{ text.rootkit.description }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="rootkits-example">What Do Rootkits Look Like?</h3>
                                    <p className="text-content">{ text.rootkit.example }</p>
                                </div>
                                <div className="text-content-wrapper">
                                    <h3 className="text-content-title" id="rootkits-mitigation">How Can I Protect Myself Rootkits?</h3>
                                    <p className="text-content">{ text.rootkit.mitigation }</p>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
                <Footer />
                <ParticleJS />
            </motion.div>
        )
    }
}
